import { get, isEmpty } from 'lodash';

// @tcc
import envDetect from '@tcc/env-detect';
import { getUpgradeLink } from '@tcc/product-packaging-web';

// selectors
import queryString from 'query-string';
import { getActiveFieldCentroid } from 'current/selectors';
import { getAccountCountry } from 'user/selectors';

// util
import { determineEnv } from 'util/env';
import { getSearchParamOnPluginURL } from './queryString';

// constants
import { FIELD_VIEW_URL } from '../constants/urls';

/** Is URL is in the form that specifies a domain at beginning? */
export const doesUrlIncludeDomainName = (url) =>
  (/(http|https|HTTP|HTTPS):\/\//g).test(url); // Like: "https://"

/** Remove querystring from URL. */
export const stripQuerystring = (url) => {
  const queryStringIndex = url.indexOf('?');
  return queryStringIndex === -1 ? url : url.substring(0, queryStringIndex);
};

export const buildUpgradeUrl = (state) => {
  const countryCode = getAccountCountry(state);
  return getUpgradeLink(countryCode);
};

export const generateWinfieldUrl = (state) => {
  const centroid = getActiveFieldCentroid(state);

  if (!isEmpty(centroid)) {
    const querystring = queryString.stringify({
      lat: get(centroid, 'coordinates[1]'),
      lng: get(centroid, 'coordinates[0]'),
      from: 'climate'
    });

    const targetBasePath = '/webapp/v4/auth/ssotoken?action=init&app=r7_web';
    let ssoDomain, targetDomain, partnerSpId;

    switch (determineEnv()) {
      case envDetect.environments.QA1:
      case envDetect.environments.LOCAL:
        targetDomain = 'r7webapi.preprod.farmsat-nafta.com';
        partnerSpId = 'r7webapi.preprod.farmsat-nafta.com';
        ssoDomain = 'ssoqa.landolakesinc.com';
        break;
      case envDetect.environments.PRODUCTION:
        targetDomain = 'www.api.winfield.r7tool.com';
        partnerSpId = 'www.api.winfield.r7tool.com';
        ssoDomain = 'sso.landolakesinc.com';
        break;
      default:
        return window.location.href;
    }

    // Build target url, needs to be encoded
    const targetUrl = encodeURIComponent(
      `https://${targetDomain}${targetBasePath}&${querystring}`
    );

    // Attach the target url to the sso link as a TargetResource
    return `https://${ssoDomain}/idp/startSSO.ping?PartnerSpId=${partnerSpId}&TargetResource=${targetUrl}`;
  }
  return window.location.href;
};

export const getOperationalTableViewUrl = () => {
  const clientId = getSearchParamOnPluginURL('client-id');
  return `${FIELD_VIEW_URL.OPERATIONAL_TABLE_VIEW}${clientId ? `?client-id=${clientId}` : ''}`;
};

export const getScriptCreatorUrl = () => {
  const clientId = getSearchParamOnPluginURL('client-id');
  return `${FIELD_VIEW_URL.SCRIPT_CREATOR}${clientId ? `?client-id=${clientId}` : ''}`;
};

/**
 * Removes protocol and domain from a URL.
 *
 * @param {string} url - The URL from which to strip the domain.
 * @returns {string} The URL without the protocol and domain.
 */
export const stripDomain = (url) => {
  return url?.replace(/^[^/]*\/\/[^/]*/, '');
};
